// Colored Tag matching the 4 license statuses.

import { Tag } from 'antd';
import type { LicenseStatus } from './licenses.api';

const COLOR: Record<LicenseStatus, string> = {
  pending: 'default',
  active: 'green',
  expired: 'red',
  revoked: 'volcano',
};
const LABEL: Record<LicenseStatus, string> = {
  pending: 'Chưa kích hoạt',
  active: 'Active',
  expired: 'Hết hạn',
  revoked: 'Đã thu hồi',
};

export function LicenseStatusBadge({ status }: { status: LicenseStatus }) {
  return <Tag color={COLOR[status]}>{LABEL[status]}</Tag>;
}
